import { CSSObject } from "@emotion/react";

export const modalCss = {
  zIndex: 99,
};

export const modalContentWrapperCss: CSSObject = {
  "&": {
    width: "100%",
    maxWidth: "800px",
    height: "auto",
    maxHeight: "85vh",
  },
};

export const modalFooterCss: CSSObject = {
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "end",
  alignItems: "center",
  minHeight: "unset",
};

export const editFormFooterButtonsWrapperCss: CSSObject = {
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
};
